import React from "react";
import { Link } from "react-router-dom";
import { Check, ArrowRight, Sparkles } from "lucide-react";

const FEATURES = [
  "Instant automated quote calculator",
  "Set up and ready within 2 business days",
  "Unlimited quotes per month",
  "Branded with your logo, colours, and business name",
  "Email notification on every accepted quote",
  "Simple setup — no technical skills needed",
];

export default function Pricing() {
  return (
    <div className="relative min-h-[80vh] bg-[#0A1628] text-[#F8FAFC] py-20">
      <div className="absolute inset-0 so-grid opacity-25 pointer-events-none" />
      <div className="absolute -top-40 left-1/2 -translate-x-1/2 w-[600px] h-[600px] so-glow-blue pointer-events-none" />
      <div className="absolute bottom-0 right-0 w-[420px] h-[420px] so-glow-cyan pointer-events-none" />

      <div className="relative max-w-5xl mx-auto px-6">
        <div className="text-center max-w-2xl mx-auto">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-[#06B6D4]/30 bg-[#06B6D4]/5 text-xs uppercase tracking-widest text-[#06B6D4] font-mono">
            Pricing
          </div>
          <h1 className="mt-6 font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight">
            One plan. Everything you need.
          </h1>
          <p className="mt-5 text-[#94A3B8] text-base sm:text-lg leading-relaxed">
            Start your free 28-day trial — no charge until day 28, cancel anytime.
          </p>
        </div>

        <div className="mt-14 grid place-items-center">
          <div
            data-testid="pricing-card-quotesnap-pro"
            className="relative so-card-elevated rounded-2xl sm:rounded-3xl p-6 sm:p-10 lg:p-12 w-full max-w-2xl so-rise"
          >
            <span className="absolute -top-3 left-1/2 -translate-x-1/2 inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-[#06B6D4] text-[#0A1628] text-[11px] uppercase font-bold tracking-widest">
              <Sparkles size={12} /> 28-day free trial
            </span>

            <div className="text-center">
              <div className="uppercase text-xs tracking-widest text-[#06B6D4] font-mono">
                QuoteSnap Pro
              </div>
              <div className="mt-5 flex items-baseline justify-center gap-1.5">
                <span className="font-display text-5xl sm:text-6xl lg:text-7xl font-extrabold tracking-tight">
                  $79
                </span>
                <span className="font-display text-xl sm:text-2xl font-bold text-[#94A3B8]">AUD</span>
                <span className="text-[#94A3B8] text-sm sm:text-base">/ month</span>
              </div>
              <div className="mt-3 text-[#06B6D4] text-sm font-medium">
                Start free — no charge for 28 days
              </div>
            </div>

            <div className="my-9 h-px w-full bg-gradient-to-r from-transparent via-white/15 to-transparent" />

            <div className="uppercase text-[11px] tracking-widest text-[#94A3B8] font-mono mb-4">
              What's included
            </div>
            <ul className="space-y-3.5">
              {FEATURES.map((f) => (
                <li key={f} className="flex items-start gap-3 text-[#F8FAFC] text-[15px]">
                  <span className="mt-1 inline-flex w-5 h-5 rounded-full bg-[#06B6D4]/15 items-center justify-center shrink-0">
                    <Check size={12} className="text-[#06B6D4]" />
                  </span>
                  <span>{f}</span>
                </li>
              ))}
            </ul>

            <div className="mt-10">
              <Link
                to="/get-started"
                data-testid="pricing-cta-quotesnap-pro"
                className="btn-pink w-full inline-flex items-center justify-center gap-2 rounded-full px-5 py-4 text-base font-semibold"
              >
                Start free trial <ArrowRight size={18} />
              </Link>
              <div className="mt-3 text-center text-xs text-[#94A3B8]">
                Tell us about your business · We configure your widget · Start your free trial.
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 text-center text-xs uppercase tracking-widest text-[#94A3B8] font-mono">
          Billed monthly · AUD · Powered by Stripe
        </div>
      </div>
    </div>
  );
}
